import { lazy } from "react"

export const FuelTypeById = lazy(() => import("./FuelTypeById"))
